import DownloadView from './Download/DownloadBlockView';
import DownloadEdit from './Download/DownloadBlockEdit';
//noinspection NpmUsedModulesInstalled
import downloadSVG from '@plone/volto/icons/download.svg';
import { defineMessages } from 'react-intl';
import reducers from './reducers';

const applyConfig = (config) => {
  config.blocks.blocksConfig.download = {
    id: 'download',
    title: 'Download',
    icon: downloadSVG,
    group: 'common',
    view: DownloadView,
    edit: DownloadEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  defineMessages({
    download: {
      id: 'trans_title_download',
      defaultMessage: 'Download',
    },
  });

  config.addonReducers = { ...config.addonReducers, ...reducers };
  return config;
};

export default applyConfig;
